export default __webpack_public_path__ + "6a4d362c47f45a21e5904149b42e038c.svg";